/**
 * @author        david.loehr@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Building Floor plan Unit
 */

import { isValid } from 'date-fns'

/**
 * Given a string date like `2020-02-13`, return a Date object for that date.
 *
 * Note that the naive approach of `new Date('2020-02-13')` will give you `Wed Feb 12 2020 19:00:00 GMT-0500 (Eastern Standard Time)`
 * (or some similarly "off by a few hours and a day too early" value in your timezone)
 *
 * @param dateAvailable expected to be in `YYYY/MM/DD` or `YYYY-MM-DD` format, but may be in `MM/DD/YY` format or some other
 * "weird" format the BE gave us
 */
export function stringToLocalDate(dateAvailable: string) {
  const date = new Date(dateAvailable)
  if (!isValid(date)) {
    return undefined
  }
  if (date.getHours() === 0 && date.getMinutes() === 0) {
    return date
  }
  date.setTime(date.getTime() + 60000 * date.getTimezoneOffset())
  return date
}
